import React, { useEffect } from 'react';

const PushSubscription = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        registration.pushManager.getSubscription()
          .then(subscription => {
            if (subscription) {

              const key = subscription.getKey ? subscription.getKey('p256dh') : null;
              const auth = subscription.getKey ? subscription.getKey('auth') : null;
              if (key) {
              }
              if (auth) {
              }
            } else {
            }
          })
          .catch(err => console.error("Error getting subscription:", err));
      });
    }
  }, []);

  return (
    <div>
      <h2>Push Subscription Info</h2>
      <p>Check the browser console for subscription details.</p>
    </div>
  );
};

export default PushSubscription;
